module.exports = __webpack_public_path__ + "static/mybusiness-a83320f2e38e79bf3c69983a777a5b55.jpg";